import { Component, ViewChild, ElementRef } from '@angular/core';
import { ShopService } from './services/shop.service';
import { LoaderService } from './services/loader.service';
import { MessageService } from './services/message.service';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { ChangeDetectorRef } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
    selector: 'my-siteinfo',
    templateUrl: '/siteinfo.html?'

})

export class SiteInfoComponent {

  subscriptions: Subscription[] = []
  myDataShop: any = [];
  myData: any = [];
  myForm: FormGroup;
  which = '0';

  shopKey: string;

  ReplaceDeliveryPhotoBuildingFront = true;

  mySections = [
    { Section: 0, Name: "Introduction", FormName: "" }
    , { Section: 1, Name: "Stage 1", FormName: "BusinessInfo" }
    , { Section: 2, Name: "Stage 2", FormName: "AuditInfo" }
    , { Section: 3, Name: "Stage 3", FormName: "Acknowledgement" }  
  ]

  isFormValid(path: string) {
    if (path == '') { return true; }
    const control = this.myForm.get(path);
    return control ? control.valid : false;
  }


  myDataBusinessType = [
    { Type: "Optics" }
    , { Type: "Audiology" }
    , { Type: "Domiciliary-Optics" }
    , { Type: "Domiciliary-Audiology" }
  ]

  myDataAddressOk = [
    { Type: "Yes – the address shown is correct" }
    , { Type: "No - I need to provide the correct address" }
    , { Type: "Address not shown / unable to confirm" }
  ]

  myDataOptIn = [
    { Type: "Yes – we wish to opt in and provide the audit information needed to prepare and organise our site visit" }
    , { Type: "No – we do not want to opt in at this stage" }
    , { Type: "Unsure – we would like more information before deciding" }
  ]

  myDataOptInNotNow = [
    { Type: "Access concerns" }
    , { Type: "Security concerns" }
    , {  Type: "Cost concerns" }
    , { Type: "Need more information about how in -night delivery would work" }
    , { Type: "Do not see a business need at this stage" }
    , { Type: "Other – please specify" }
  ]

  myDataAlarm = [{ Type: "No" }
    , { Type: "Yes" }]

  myDataKey = [{ Type: "No" }
    , { Type: "Yes" }]
  
  myDataLocationDescription = [
    { Type: "High street" }
    , { Type: "Retail park" }
    , { Type: "Shopping centre" }
    , { Type: "Supermarket, site within another retailer or third - party managed site" }
    , { Type: "Office - managed building" }
    , { Type: "Other – please specify" }
  ]

  myDataKnownAccessRestrictions = [
    { Type: "No access restrictions or barriers" }
    , { Type: "Don’t know" }
    , { Type: "Yes - please specify" }
  ]

  myDataAccessRestrictions = [
     { Type: "Parking or vehicle access restriction" }
    , { Type: "Pedestrianised area or traffic restriction" }
    , { Type: "Shopping centre, centre - managed or third - party controlled access" }
    , { Type: "Office - managed building access" }
    , { Type: "Restricted overnight delivery times" }
    , { Type: "Locked shared entrance, shutters or external barriers" }
    , { Type: "Other – please specify" }
  ]

  myDataInternalDrop = [
    { Type: "Yes"  }
    ,{ Type: "No" }
    , { Type: "Unsure" }
  ]

  myDataSiteVisitContact = [
    { Type: "Same as Partner Contact" }
    , { Type: "Different Contact" }
  ]

  //////////////////////////



  myTxtAreaHeight = "200px"
  txtAreaSize(event: any) {
    let textArea = event.target; //this.myForm.controls['myFormDetails']
    this.myTxtAreaHeight = (textArea.scrollHeight < 250 ? 250 : textArea.scrollHeight) + "px"
  }

    constructor(private shopservice: ShopService
      , private loaderService: LoaderService
      , private fb: FormBuilder
      , public http: HttpClient
      , public messageService: MessageService
      , private sanitizer: DomSanitizer) {


      this.myDataShop = this.shopservice.getShopFromStorage();
      //console.log(this.myDataShop)
      if (!this.myDataShop?.InNightAudit){
       window.location.href = "/portal/shop/helpdesk";
      }

  
      this.loadForm()
  }

  isLoadedForm = false

  BusinessNameReadOnly = true;
  EPOSNumberReadOnly = true;
  Address1ReadOnly = true;
  Address2ReadOnly = true;
  Address3ReadOnly = true;
  PostCodeReadOnly = true;

  loadForm(myForm: any = null) {
  
    this.isLoadedForm = (myForm == null ? false : true)

    this.myForm = this.fb.group({
      BusinessInfo: this.fb.group({
        BusinessType: [(myForm?.BusinessInfo?.BusinessType ? myForm?.BusinessInfo?.BusinessType : ''), Validators.required],
        BusinessName: [(this.myDataShop.Name), Validators.required],
        EPOSNumber: [(this.myDataShop.Key), Validators.required],
        Address1: [(this.myDataShop.Address1), Validators.required],
        Address2: [(this.myDataShop.Address2)],
        Address3: [(this.myDataShop.City)],
        PostCode: [(this.myDataShop.Postcode), Validators.required],
        AddressOk: [(myForm?.BusinessInfo?.AddressOk ? myForm?.BusinessInfo?.AddressOk : ''), Validators.required],
        //CorrectAddress: [''],
        PartnerContactName: [(myForm?.BusinessInfo?.PartnerContactName ?myForm?.BusinessInfo?.PartnerContactName : ''), Validators.required],
        Email: [(myForm?.BusinessInfo?.Email ? myForm?.BusinessInfo?.Email : ''), [Validators.required, Validators.email]],
        Phone: [(myForm?.BusinessInfo?.Phone ? myForm?.BusinessInfo?.Phone : ''), Validators.required],
        OptIn: [(myForm?.BusinessInfo?.OptIn ? myForm?.BusinessInfo?.OptIn : ''), Validators.required],
        OptInNotNow: [(myForm?.BusinessInfo?.OptInNotNow ? myForm?.BusinessInfo?.OptInNotNow : '')],
        OptInNotNowOther: [(myForm?.BusinessInfo?.OptInNotNowOther ? myForm?.BusinessInfo?.OptInNotNowOther : '')],
      }),
      AuditInfo: this.fb.group({
        EmergencyContactName: [(myForm?.AuditInfo?.EmergencyContactName ? myForm?.AuditInfo?.EmergencyContactName : ''), Validators.required],
        EmergencyEmail: [(myForm?.AuditInfo?.EmergencyEmail ? myForm?.AuditInfo?.EmergencyEmail : ''), [Validators.required, Validators.email]],
        EmergencyPhone: [(myForm?.AuditInfo?.EmergencyPhone ? myForm?.AuditInfo?.EmergencyPhone : ''), Validators.required],
        Alarm: [(myForm?.AuditInfo?.Alarm ? myForm?.AuditInfo?.Alarm : ''), Validators.required],
        CodeFobCollection: [(myForm?.AuditInfo?.CodeFobCollection ? myForm?.AuditInfo?.CodeFobCollection : '')],
        LocationDescription: [(myForm?.AuditInfo?.LocationDescription ? myForm?.AuditInfo?.LocationDescription : ''), Validators.required],
        LocationDescriptionOther: [(myForm?.AuditInfo?.LocationDescriptionOther ? myForm?.AuditInfo?.LocationDescriptionOther : '')],
        Key: [(myForm?.AuditInfo?.Key ? myForm?.AuditInfo?.Key : ''), Validators.required],
        KeyCollectionDate: [(myForm?.AuditInfo?.KeyCollectionDate ? myForm?.AuditInfo?.KeyCollectionDate : '')],
        KnownAccessRestrictions: [(myForm?.AuditInfo?.KnownAccessRestrictions ? myForm?.AuditInfo?.KnownAccessRestrictions : ''), Validators.required],
        AccessRestrictions: [(myForm?.AuditInfo?.AccessRestrictions ? myForm?.AuditInfo?.AccessRestrictions : '')],
        AccessRestrictionsOther: [(myForm?.AuditInfo?.AccessRestrictionsOther ? myForm?.AuditInfo?.AccessRestrictionsOther : '')],
        InternalDrop: [(myForm?.AuditInfo?.InternalDrop ? myForm?.AuditInfo?.InternalDrop : ''), Validators.required],
        InternalDropDetails: [(myForm?.AuditInfo?.InternalDropDetails ? myForm?.AuditInfo?.InternalDropDetails : ''), Validators.required],
        SiteVisitContact: [(myForm?.AuditInfo?.SiteVisitContact ? myForm?.AuditInfo?.SiteVisitContact : ''), Validators.required],
        SiteVisitContactOtherDetailsName: [(myForm?.AuditInfo?.SiteVisitContactOtherDetailsName ? myForm?.AuditInfo?.SiteVisitContactOtherDetailsName : '')],
        SiteVisitContactOtherDetailsEmail: [(myForm?.AuditInfo?.SiteVisitContactOtherDetailsEmail ? myForm?.AuditInfo?.SiteVisitContactOtherDetailsEmail : '')],
        SiteVisitContactOtherDetailsPhone: [(myForm?.AuditInfo?.SiteVisitContactOtherDetailsPhone ? myForm?.AuditInfo?.SiteVisitContactOtherDetailsPhone : '')],
        AnythingElse: [(myForm?.AuditInfo?.AnythingElse ? myForm?.AuditInfo?.AnythingElse : '')]
      })
      ,
      Acknowledgement: this.fb.group({
        Acknowledgement: [(myForm?.Acknowledgement?.Acknowledgement ? myForm?.Acknowledgement?.Acknowledgement : ''), Validators.required],
      }),

    });



    this.BusinessNameReadOnly = true;
    this.EPOSNumberReadOnly = true;
    this.Address1ReadOnly = true;
    this.Address2ReadOnly = true;
    this.Address3ReadOnly = true;
    this.PostCodeReadOnly = true;


    if (this.isLoadedForm) { 
      this.onChangeAddressOk({ target: { value: this.myForm.get('BusinessInfo.AddressOk')?.value } })
      this.onChangeOptIn({ target: { value: this.myForm.get('BusinessInfo.OptIn')?.value } });
      this.onChangeOptInNotNow({ target: { value: this.myForm.get('BusinessInfo.OptInNotNow')?.value } })
      this.onChangeAccessRestrictions({ target: { value: this.myForm.get('AuditInfo.AccessRestrictions')?.value } })
    }


    this.addConditionalRequired('AuditInfo.LocationDescription', 'AuditInfo.LocationDescriptionOther', 'Other – please specify');
    this.addConditionalRequired('AuditInfo.KnownAccessRestrictions', 'AuditInfo.AccessRestrictions', 'Yes - please specify');
    this.addConditionalRequired('AuditInfo.AccessRestrictions', 'AuditInfo.AccessRestrictionsOther', 'Other – please specify');
    this.addConditionalRequired('AuditInfo.SiteVisitContact', 'AuditInfo.SiteVisitContactOtherDetailsName', 'Different Contact');
    this.addConditionalRequired('AuditInfo.SiteVisitContact', 'AuditInfo.SiteVisitContactOtherDetailsEmail', 'Different Contact');
    this.addConditionalRequired('AuditInfo.SiteVisitContact', 'AuditInfo.SiteVisitContactOtherDetailsPhone', 'Different Contact');

  }

  getInvalidFields(form: FormGroup): string[] {
    const invalid: string[] = [];

    Object.keys(form.controls).forEach(key => {
      const control = form.get(key);

      if (control instanceof FormGroup) {
        const childInvalid = this.getInvalidFields(control);
        invalid.push(...childInvalid.map(childKey => `${key}.${childKey}`));
      } else if (control && control.invalid) {
        invalid.push(key);
      }
    });

    return invalid;
  }



  dspEarlySubmit = false;
  onChangeOptIn(event: any) {
    const value = event.target.value;
    const control = this.myForm.get('BusinessInfo.OptInNotNow');
    const ctrlLocationDescription = this.myForm.get('AuditInfo.LocationDescription');
    const ctrlKnownAccessRestrictions = this.myForm.get('AuditInfo.KnownAccessRestrictions');
    const ctrlInternalDrop = this.myForm.get('AuditInfo.InternalDrop');
    const ctrlInternalDropDetails = this.myForm.get('AuditInfo.InternalDropDetails');

    const ctrlKey = this.myForm.get('AuditInfo.Key');
    const ctrlAlarm = this.myForm.get('AuditInfo.Alarm');

    const ctrlSiteVisitContact = this.myForm.get('AuditInfo.SiteVisitContact');
    const ctrlEmergencyContactName = this.myForm.get('AuditInfo.EmergencyContactName');
    const ctrlEmergencyEmail = this.myForm.get('AuditInfo.EmergencyEmail');
    const ctrlEmergencyPhone = this.myForm.get('AuditInfo.EmergencyPhone');
    const ctrlAcknowledgement = this.myForm.get('Acknowledgement.Acknowledgement');

 
    if (value.includes('Unsure ') || value.includes('No ')) {
      control.setValidators([Validators.required]);
      control.updateValueAndValidity();
      
      ctrlLocationDescription.clearValidators();
      ctrlLocationDescription.updateValueAndValidity();
      ctrlKnownAccessRestrictions.clearValidators();
      ctrlKnownAccessRestrictions.updateValueAndValidity();
      ctrlInternalDrop.clearValidators();
      ctrlInternalDrop.updateValueAndValidity();
      ctrlInternalDropDetails.clearValidators();
      ctrlInternalDropDetails.updateValueAndValidity();


      ctrlKey.clearValidators();
      ctrlKey.updateValueAndValidity();

      ctrlAlarm.clearValidators();
      ctrlAlarm.updateValueAndValidity();

      ctrlSiteVisitContact.clearValidators();
      ctrlSiteVisitContact.updateValueAndValidity();

      ctrlAcknowledgement.clearValidators();
      ctrlAcknowledgement.updateValueAndValidity();
      ctrlAcknowledgement.setValue(false);

      ctrlEmergencyContactName.clearValidators();
      ctrlEmergencyContactName.updateValueAndValidity();
      ctrlEmergencyEmail.clearValidators();
      ctrlEmergencyEmail.updateValueAndValidity();
      ctrlEmergencyPhone.clearValidators();
      ctrlEmergencyPhone.updateValueAndValidity();

      this.dspEarlySubmit = true;
    }
    else {
      control.clearValidators();
      control.setValue(''); // optional: clear when not required
      control.updateValueAndValidity();

      ctrlLocationDescription.setValidators([Validators.required]);
      ctrlLocationDescription.updateValueAndValidity();
      ctrlKnownAccessRestrictions.setValidators([Validators.required]);
      ctrlKnownAccessRestrictions.updateValueAndValidity();
      ctrlInternalDrop.setValidators([Validators.required]);
      ctrlInternalDrop.updateValueAndValidity();
      ctrlInternalDropDetails.setValidators([Validators.required]);
      ctrlInternalDropDetails.updateValueAndValidity();

      ctrlKey.setValidators([Validators.required]);
      ctrlKey.updateValueAndValidity();

      ctrlAlarm.setValidators([Validators.required]);
      ctrlAlarm.updateValueAndValidity();

      ctrlSiteVisitContact.setValidators([Validators.required]);
      ctrlSiteVisitContact.updateValueAndValidity();

      ctrlAcknowledgement.setValidators([Validators.required]);
      ctrlAcknowledgement.updateValueAndValidity();
      ctrlAcknowledgement.setValue(true);

      ctrlEmergencyContactName.setValidators([Validators.required]);
      ctrlEmergencyContactName.updateValueAndValidity();
      ctrlEmergencyEmail.setValidators([Validators.required, Validators.email]);
      ctrlEmergencyEmail.updateValueAndValidity();
      ctrlEmergencyPhone.setValidators([Validators.required]);
      ctrlEmergencyPhone.updateValueAndValidity();

      this.dspEarlySubmit = false;
    }



    this.addConditionalRequired('AuditInfo.LocationDescription', 'AuditInfo.LocationDescriptionOther', 'Other – please specify');
    this.addConditionalRequired('AuditInfo.KnownAccessRestrictions', 'AuditInfo.AccessRestrictions', 'Yes - please specify');
    this.addConditionalRequired('AuditInfo.AccessRestrictions', 'AuditInfo.AccessRestrictionsOther', 'Other – please specify');
    this.addConditionalRequired('AuditInfo.SiteVisitContact', 'AuditInfo.SiteVisitContactOtherDetailsName', 'Different Contact');
    this.addConditionalRequired('AuditInfo.SiteVisitContact', 'AuditInfo.SiteVisitContactOtherDetailsEmail', 'Different Contact');
    this.addConditionalRequired('AuditInfo.SiteVisitContact', 'AuditInfo.SiteVisitContactOtherDetailsPhone', 'Different Contact');



    return;
  }

  onChangeOptInNotNow(event: any) {
    const value = event.target.value;
    const checked = event.target.checked;

    const control = this.myForm.get('BusinessInfo.OptInNotNow');
    let current: string[] = control?.value || [];

    // If "No" is selected → clear everything and set only "No"
    if (value === 'No' && checked) {
      control?.setValue(['No']);
      return;
    }

    // If "No" is unselected → clear all
    if (value === 'No' && !checked) {
      control?.setValue([]);
      return;
    }

    // If selecting something else while "No" is active → remove "No"
    if (current.includes('No')) {
      current = [];
    }

    // Normal checkbox behaviour
    if (checked) {
      control?.setValue([...current, value]);
    } else {
      control?.setValue(current.filter(x => x !== value));
    }
  }

 

  onChangeAccessRestrictions(event: any) {
    const value = event.target.value;
    const checked = event.target.checked;

    const control = this.myForm.get('AuditInfo.AccessRestrictions');
    let current: string[] = control?.value || [];

    // // If "No" is selected → clear everything and set only "No"
    // if (value === 'No access restrictions or barriers' && checked) {
    //   control?.setValue(['No access restrictions or barriers']);
    //   return;
    // }

    // // If "No" is unselected → clear all
    // if (value === 'No access restrictions or barriers' && !checked) {
    //   control?.setValue([]);
    //   return;
    // }

    // // If selecting something else while "No" is active → remove "No"
    // if (current.includes('No access restrictions or barriers')) {
    //   current = [];
    // }

    // Normal checkbox behaviour
    if (checked) {
      control?.setValue([...current, value]);
    } else {
      control?.setValue(current.filter(x => x !== value));
    }
  }

  onChangeAddressOk(event: any) {

    const value = event.target.value;

    const ctrlAddress1 = this.myForm.get('BusinessInfo.Address1');
    const ctrlAddress2 = this.myForm.get('BusinessInfo.Address2');
    const ctrlAddress3 = this.myForm.get('BusinessInfo.Address3');
    const ctrlPostCode = this.myForm.get('BusinessInfo.PostCode');

    // If "No" is selected → clear everything and set only "No"
    if (value === 'No - I need to provide the correct address' || value === 'Address not shown / unable to confirm') {
      ctrlAddress1.setValue('');
      ctrlAddress2.setValue('');
      ctrlAddress3.setValue('');
      ctrlPostCode.setValue('');
 
      this.BusinessNameReadOnly = false;
      this.EPOSNumberReadOnly = false;
      this.Address1ReadOnly = false;
      this.Address2ReadOnly = false;
      this.Address3ReadOnly = false;
      this.PostCodeReadOnly = false;

      return;
    }
    else {

      this.BusinessNameReadOnly = true;
      this.EPOSNumberReadOnly = true;
      this.Address1ReadOnly = true;
      this.Address2ReadOnly = true;
      this.Address3ReadOnly = true;
      this.PostCodeReadOnly = true;

      ctrlAddress1.setValue(this.myDataShop.Address1);
      ctrlAddress2.setValue(this.myDataShop.Address2);
      ctrlAddress3.setValue(this.myDataShop.City);
      ctrlPostCode.setValue(this.myDataShop.Postcode);
      return;

    }

  }

  addConditionalRequired(triggerPath: string, targetPath: string, requiredValue: any) {
    const trigger = this.myForm.get(triggerPath);
    const target = this.myForm.get(targetPath);

    if (!trigger || !target) return;

  //  trigger.valueChanges.subscribe(value => {
    //  if (value.substring(0, requiredValue.length) === requiredValue || value === requiredValue) {
      //  target.setValidators([Validators.required]);
     // } else {
      //  target.clearValidators();
      //  target.setValue(''); // optional: clear when not required
     // }

      //target.updateValueAndValidity();
    //});

    trigger.valueChanges.subscribe(value => {
      const isMatch =
        typeof value === 'string' &&
        (value.startsWith(requiredValue) || value === requiredValue);

      if (isMatch) {
        target.setValidators([Validators.required]);
      } else {
        target.clearValidators();
        target.setValue(''); // optional
      }

      target.updateValueAndValidity();
    });


  }

  resetIfSame(event: any, controlPath: string) {
    const control = this.myForm.get(controlPath);
    const clickedValue = event.target.value;

    if (control?.value === clickedValue) {
      control.setValue(null);
    }
  }

  Submit() {

    let myPost = {
      "Form": this.myForm.value
      , "Shop": this.myDataShop
    }

   
    let isValid = true;

    if (!this.isFormValid('BusinessInfo') || !this.isFormValid('AuditInfo') || !this.isFormValid('Acknowledgement')) {
      isValid = false;

      this.messageService.emitChange({ "Css": "error", "Message":"Please complete all mandatory fields before submitting" });

    }


    if(isValid) {
    
      this.loaderService.emitChange(true);

      this.http.post('/SiteInfo/FormSubmit', JSON.stringify(myPost))
        .subscribe(
          (res: any) => {
            this.loaderService.emitChange(false);
            //console.log(JSON.stringify(res));
            if (res.Result != "Success") {
              this.messageService.emitChange({ "Css": "error", "Message": res.Message });
            } else {
              this.messageService.emitChange({ "Css": "success", "Message": res.Message });
              //this.list();
              this.GetLatest();
              this.which = '0';
              this.loadForm();
            }
          });
    }
  }


  myLastFormSubmission: any = null;

  GetLatest() {
    const myPost = { Shop: this.myDataShop };

    this.loaderService.emitChange(true);

    this.http.post('/SiteInfo/GetLatestForm', myPost)
      .subscribe(
        (res: any) => {
          this.loaderService.emitChange(false);

          if (res.error) {
            this.messageService.emitChange({ Css: "error", Message: res.Message });
          } else {
            this.myLastFormSubmission = res;
         
          }
        },
        (err) => {
          this.loaderService.emitChange(false);
          this.messageService.emitChange({ Css: "error", Message: err  });
        }
      );
  }


    async ngOnInit(): Promise<void> {

      //if (localStorage.getItem("Shop").toUpperCase() != 'B3793C5C-2DED-4B4C-B4AD-DECE545C1345'){
       // window.location.href = "/portal/shop/helpdesk";
      //}

      //check my responses....

      this.GetLatest(); 
      
    }

  

    public ngOnDestroy() {
        this.subscriptions.forEach((subscription) => { subscription.unsubscribe(); });
    }

}






